// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12fNl","right":"Footer_right__pIxyR","buttons":"Footer_buttons__3oBqx"};